"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProcessor = exports.PaymentProcessors = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PaymentProcessors = ['RAINFOREST', 'STRIPE', 'PLAID', 'SVB', 'MANUAL'];
/**
 * What actually moved the funds and owns the `paymentProcessorReferenceID` on a payment or refund — a
 * card processor, an ACH originator, or the bank itself. Receivables run through RAINFOREST, or STRIPE
 * on pre-migration invoices (read-only going forward); payables run through PLAID or SVB. MANUAL covers
 * money that moved off-platform (check, cash, wire) and is the only value with no reference id.
 * Deliberately not v1's `SupportedPaymentProcessorTransport`, which gates charge routing, nor v1's
 * payables `PaymentProvider`, which omits the card processors.
 */
exports.PaymentProcessor = typebox_1.Type.Union(exports.PaymentProcessors.map((paymentProcessor) => typebox_1.Type.Literal(paymentProcessor)));
//# sourceMappingURL=payment-processor.js.map